// Imprime un documento HTML autocontenido SIN abrir ventanas: lo carga en un <iframe> oculto
// (srcdoc) y dispara la impresión de ese iframe desde acá. Es la técnica estándar de las
// librerías de impresión, y evita los dos problemas que tuvimos:
//   - `window.open + document.write` → Chrome rompe document.write (hoja en blanco en la PC).
//   - `window.open(blobURL)` → Chrome falla al imprimir un blob: ("error al imprimir la página").
// El iframe es del mismo origen, así que podemos llamar a su print() sin restricciones.
export function imprimirDocumentoHTML(html) {
  const anterior = document.getElementById("__iframe_impresion");
  if (anterior) anterior.remove();

  const iframe = document.createElement("iframe");
  iframe.id = "__iframe_impresion";
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.cssText = "position:fixed; right:0; bottom:0; width:0; height:0; border:0;";

  let impreso = false;
  iframe.onload = () => {
    // OJO: el iframe también dispara `load` con su documento vacío inicial (about:blank).
    // Si imprimimos ahí sale una hoja EN BLANCO además de la buena. Por eso: una sola vez,
    // y solo cuando el documento ya tiene contenido.
    if (impreso) return;
    const doc = iframe.contentDocument;
    if (!doc || !doc.body || doc.body.childElementCount === 0) return;
    impreso = true;

    const quitar = () => { if (iframe.parentNode) iframe.remove(); };
    try {
      const win = iframe.contentWindow;
      win.onafterprint = () => setTimeout(quitar, 500);
      win.focus();
      win.print();
    } catch (e) {
      quitar();
    }
    // Respaldo: sacar el iframe más tarde por si `afterprint` no dispara.
    setTimeout(quitar, 120000);
  };

  // El contenido se define ANTES de insertarlo, así carga directo (sin el about:blank previo).
  iframe.srcdoc = html;
  document.body.appendChild(iframe);
  return true;
}
